import {ChevronDown,ChevronRight,Trash2} from 'lucide-react';
import {Card,CardHeader,CardTitle,CardContent} from '../../components/ui/card';
import {RadioGroup,RadioGroupItem} from '../../components/ui/radio-group';
import {Input} from '../../components/ui/input';
import {Button} from '../../components/ui/button';
import {motion} from 'framer-motion';
import ServiceSelector from './ServiceSelector';
import {SCHED_MODES} from '../EmployeeConfigPanel';   // reuse constant

export function ServiceConfigCard({
  config, services, onUpdate, onDelete, error,
  disabledServiceIds=[]
}){
  const setField=(key,val)=>onUpdate({...config,[key]:val});
  return(
    <Card className="border shadow-sm overflow-visible">
      <CardHeader className="flex flex-row justify-between">
        <div className="flex items-center gap-2">
          {config.expanded
            ? <ChevronDown size={18} className="cursor-pointer"
                onClick={()=>setField('expanded',false)}/>
            : <ChevronRight size={18} className="cursor-pointer"
                onClick={()=>setField('expanded',true)}/> }
          <CardTitle className="text-base">Config</CardTitle>
        </div>
        <Button variant="ghost" size="icon" onClick={()=>onDelete(config.id)}>
          <Trash2 size={16}/>
        </Button>
      </CardHeader>

      {config.expanded && (
        <CardContent className="space-y-6 pt-0 pb-4">
          {/* mode */}
          <RadioGroup value={config.mode}
            onValueChange={v=>setField('mode',v)}
            className="flex gap-4">
            <RadioGroupItem value={SCHED_MODES.EMPLOYEE_MANAGED} id={`${config.id}-emp`}>
              Employee-Managed
            </RadioGroupItem>
            <RadioGroupItem value={SCHED_MODES.BUSINESS_MANAGED} id={`${config.id}-biz`}>
              Business-Managed
            </RadioGroupItem>
          </RadioGroup>

          {config.mode===SCHED_MODES.EMPLOYEE_MANAGED && (
            <motion.div initial={{opacity:0}} animate={{opacity:1}}
              className="pl-4 space-y-3">
              <label className="flex items-center gap-2">
                Booking window
                <Input type="number" min={1} className="w-20"
                  value={config.employeeManagedConfig?.bookingWindowWeeks ?? '3'}
                  onChange={e=>
                    setField('employeeManagedConfig',{
                      ...config.employeeManagedConfig,
                      bookingWindowWeeks:+e.target.value})}/>
                weeks
              </label>
              <label className="flex items-center gap-2">
                Max concurrent
                <Input type="number" min={1} className="w-20"
                  value={config.employeeManagedConfig?.maxConcurrent ?? '1'}
                  onChange={e=>
                    setField('employeeManagedConfig',{
                      ...config.employeeManagedConfig,
                      maxConcurrent:+e.target.value})}/>
              </label>
            </motion.div>
          )}

          {config.mode===SCHED_MODES.BUSINESS_MANAGED && (
            <motion.div initial={{opacity:0}} animate={{opacity:1}}
              className="pl-4 space-y-3">
              <label className="flex items-center gap-2">
                Upload every
                <Input type="number" min={1} className="w-20"
                  value={config.businessManagedConfig?.uploadEveryNDays ?? '7'}
                  onChange={e=>
                    setField('businessManagedConfig',{
                      ...config.businessManagedConfig,
                      uploadEveryNDays:+e.target.value})}/>
                days
              </label>
            </motion.div>
          )}

          {/* assignment */}
          <label className="flex items-center gap-2">
            <input type="checkbox" className="checkbox"
              checked={config.applyToAll}
              onChange={e=>onUpdate({...config,applyToAll:e.target.checked,services:[]})}/>
            Apply to all services
          </label>
          {!config.applyToAll && (
            <ServiceSelector
              services={services}
              selected={config.services}
              onChange={arr=>setField('services',arr)}
              disabledIds={disabledServiceIds}/>
          )}

          {error && <p className="text-xs text-red-500">{error}</p>}
        </CardContent>
      )}
    </Card>
  );
}
